// The bell voice the Rhythm Lab plays (core's bell.ts), remembered on this device.

import { BELL_VOICE_NAMES, DEFAULT_BELL, type BellVoice } from '@salsacount/core';

const KEY = 'salsacount.bell';

export function loadBell(): BellVoice {
  try {
    const v = localStorage.getItem(KEY);
    return (BELL_VOICE_NAMES as readonly string[]).includes(v ?? '') ? (v as BellVoice) : DEFAULT_BELL;
  } catch {
    return DEFAULT_BELL; // storage refused: the default, for this visit
  }
}

export function saveBell(voice: BellVoice): void {
  try {
    localStorage.setItem(KEY, voice);
  } catch {
    /* kept for this visit only */
  }
}
